<template>
  <main>
    <h1 class="page-title">Create Crypto Payout</h1>

    <form @submit.prevent="" class="payout-type-selection-wrapper">
      <input type="radio" :value="PAYOUT_TYPES.EMAIL" v-model="selectedPayoutType" name="payoutTypeRadio" id="pyt-radio-email" />
      <label for="pyt-radio-email">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#505050">
          <path fill="none" d="M0 0h24v24H0z" />
          <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" />
        </svg>
        Via email
      </label>

      <input type="radio" :value="PAYOUT_TYPES.DIRECT" v-model="selectedPayoutType" name="payoutTypeRadio" id="pyt-radio-direct" />
      <label for="pyt-radio-direct" @click="sendPayoutDirectTabClickEvent()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#505050">
          <path fill="none" d="M0 0h24v24H0z" />
          <path d="M18 4H6C3.79 4 2 5.79 2 8v8c0 2.21 1.79 4 4 4h12c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4zm-1.86 9.77c-.24.2-.57.28-.88.2L4.15 11.25C4.45 10.52 5.16 10 6 10h12c.67 0 1.26.34 1.63.84l-3.49 2.93zM6 6h12c1.1 0 2 .9 2 2v.55c-.59-.34-1.27-.55-2-.55H6c-.73 0-1.41.21-2 .55V8c0-1.1.9-2 2-2z" />
        </svg>
        Direct to wallet
      </label>

      <input type="radio" :value="PAYOUT_TYPES.BATCH" v-model="selectedPayoutType" name="payoutTypeRadio" id="pyt-radio-batch" v-if="isWhiteListedForBatch" />
      <label for="pyt-radio-batch" v-if="isWhiteListedForBatch">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#505050">
          <path fill="none" d="M0 0h24v24H0z" />
          <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z" />
        </svg>
        Batch upload
      </label>
    </form>


    <Transition>
      <!-- Payout via Email -->
      <section v-if="selectedPayoutType === PAYOUT_TYPES.EMAIL" class="email-payout-wrapper">
        <div id="create-withdrawal-form" v-if="!withdrawalApproved">
          <!--Form Container-->
          <template v-if="!isProceed">
            <vs-row class="mt-4">
              <vs-col
                type="flex"
                vs-justify="left"
                vs-align="center"
                vs-w="11"
                vs-xs="11"
                vs-sm="9"
                vs-lg="6">
                <div v-if="displayPayoutLinkCreation" class="mt-3">
                  <ul>
                    <li style="list-style-type: disc">
                      Select a recipient that will receive an email with a link
                      that allows the recipient to enter the receiving wallet
                      address.
                    </li>
                    <li style="list-style-type: disc">
                      The exchange rate used to convert your local currency to
                      crypto is fixed at the time the payout is confirmed.
                    </li>
                  </ul>

                  <div class="withdrawal-container">
                    <!--          <span style="font-style: italic">-->

                    <!--          </span>-->

                    <!--          <p>Enter your bitcoin withdrawal details below :</p>-->
                    <br />
                    <div class="withdrawal-form">
                      <vs-row class="ml-0 mb-4">
                        <vs-col
                          vs-justify="left"
                          vs-align="center"
                          vs-w="10.8"
                          vs-sm="12"
                          vs-xs="12"
                          class="p-0">
                          <label for="withdrawal-account">
                            Sent from <span style="color: #ff0000">*</span>
                            <span class="tooltip-container">
                              <info-icon
                                size="1x"
                                style="margin: 0 8px"
                                id="balance-info"
                                width="10"
                                height="10"
                                @click="showTooltip('tooltip-msg')"></info-icon>
                              <span id="tooltip-msg">
                                <span><strong>Real Balance</strong> refers to balance
                                  for real world transaction.</span>
                                <span><strong>Test Balance</strong> refers to balance
                                  that has no real value and the amount are used
                                  only for testing purposes.</span>
                              </span>
                            </span>
                          </label>
                          <select
                            id="withdrawal-account"
                            class="account-selection w-full style-select"
                            :class="{
    'select-icon-validate-danger':
      validateWithdrawalAccountError,
  }"
                            v-model="selectedBalance"
                            :disabled="inputDisabled">
                            <optgroup label="Real Balance">
                              <option
                                v-for="(item, index) in realWithdrawalAccountsList"
                                :value="item"
                                :key="index">
                                {{ item.name }}
                              </option>
                            </optgroup>
                            <optgroup label="Test Balance">
                              <option
                                v-for="(item, index) in testWithdrawalAccountList"
                                :value="item"
                                :key="index">
                                {{ item.name }}
                              </option>
                            </optgroup>
                          </select>
                          <div
                            v-if="validateWithdrawalAccountError"
                            class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to"
                            style="height: 19px">
                            <span class="span-text-validation">
                              Please select one of the balance
                            </span>
                          </div>
                        </vs-col>
                      </vs-row>

                      <vs-row class="ml-0 mb-4">
                        <vs-col
                          vs-justify="left"
                          vs-align="center"
                          vs-w="10.8"
                          vs-sm="12"
                          vs-xs="12"
                          class="p-0">
                          <label for="customer-email">
                            Recipient's Email
                            <span style="color: #ff0000">*</span></label>
                          <vs-input
                            class="inputx mb-3 w-full"
                            :danger="formSubmitted && validateEmailError"
                            danger-text="Please provide a valid e-mail address."
                            v-model.trim="customerEmailAddress"
                            id="customer-email"
                            :disabled="inputDisabled"
                            @change="onChangeEmailAddress()" />
                        </vs-col>
                      </vs-row>

                      <vs-row class="ml-0 mb-4">
                        <vs-col
                          vs-justify="left"
                          vs-align="center"
                          vs-w="5"
                          vs-sm="5"
                          vs-xs="12"
                          class="p-0 pr-3">
                          <label for="withdrawal-currency"> Payout Currency </label>
                          <div id="withdrawal-currency">
                            <span>{{ withdrawalCurrency }}</span>
                          </div>
                        </vs-col>

                        <vs-col
                          vs-justify="left"
                          vs-align="center"
                          vs-w="6"
                          vs-sm="6"
                          vs-xs="12"
                          class="p-0 pr-3">
                          <label for="withdrawal-amount">
                            Payout Amount <span style="color: #ff0000">*</span>
                          </label>
                          <vs-input
                            class="inputx mb-3 w-full"
                            :danger="formSubmitted && validateWithdrawalAmountError"
                            danger-text="Please insert the withdrawn amount and not larger than the available balance"
                            v-model.trim="withdrawalAmount"
                            id="withdrawal-amount"
                            :disabled="inputDisabled"
                            type="number"
                            min="0" />
                        </vs-col>
                      </vs-row>

                      <vs-row class="ml-0 mb-4" v-if="showCryptoField">
                        <vs-col
                          vs-justify="left"
                          vs-align="center"
                          vs-w="10.8"
                          vs-sm="12"
                          vs-xs="12"
                          class="p-0">
                          <label for="customer-email">
                            Cryptocurrency to receive
                            <span style="color: #ff0000">*</span></label>
                          <select
                            id="withdrawal-cryptocurrency"
                            class="account-selection w-full style-select"
                            :class="{
    'select-icon-validate-danger':
      validateWithdrawalCryptoError,
  }"
                            v-model="cryptoCurrency">
                            <optgroup label="Cryptocurrencies">
                              <option
                                v-for="(
                            item, index
                          ) in cryptoOptionsToWithdrawForLocal"
                                :value="item"
                                :key="index">
                                {{ formatCryptoCurrencyName(item) }}
                              </option>
                            </optgroup>
                          </select>
                          <div
                            v-if="validateWithdrawalCryptoError"
                            class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to"
                            style="height: 19px">
                            <span class="span-text-validation">
                              Please select which cryptocurrency you want the
                              recipient to receive in
                            </span>
                          </div>
                        </vs-col>
                      </vs-row>

                      <vs-row class="mt-2 mb-2">
                        <vs-col
                          vs-justify="left"
                          vs-align="center"
                          vs-w="10.8"
                          vs-sm="12"
                          vs-xs="12"
                          class="p-0">
                          <label for="customer-email">
                            Reference for payout</label>
                          <vs-textarea
                            class="inputx mb-3 w-full textarea-style"
                            :class="{
    'select-icon-validate-danger':
      validateWithdrawalRemarksError,
  }"
                            :danger="formSubmitted && validateWithdrawalRemarksError
    "
                            danger-text="Please provide a remarks or reason for withdrawal"
                            v-model.trim="withdrawalRemarks"
                            id="withdrawal-remarks"
                            :disabled="inputDisabled"
                            counter="40" />
                          <!--                <div v-if="validateWithdrawalRemarksError" class="con-text-validation span-text-validation-danger vs-input&#45;&#45;text-validation-span v-enter-to" style="height:19px">-->
                          <!--                   <span class=" span-text-validation">-->
                          <!--                  Please provide a remarks or reason for withdrawal and not exceed 40 characters.-->
                          <!--                  </span>-->

                          <!--                </div>-->
                        </vs-col>
                      </vs-row>
                      <br />

                      <!--RECIPIENT'S KYC DATA (will autopopulate once email is inserted-->
                      <div class="mb-3">
                        <h5>Recipient's KYC (optional)</h5>
                        <p class="sm:text-sm">
                          *If not provided, recipient will be prompted for the
                          information when claiming funds.
                        </p>
                      </div>

                      <vs-row class="ml-0 mb-2">
                        <vs-col
                          vs-justify="left"
                          vs-align="center"
                          vs-w="10.8"
                          vs-sm="12"
                          vs-xs="12"
                          class="p-0">
                          <label for="customer-email"> Recipient's Full Name</label>
                          <vs-input
                            class="inputx mb-3 w-full"
                            v-model.trim="recipientName"
                            id="recipient-name"
                            :disabled="inputDisabled" />
                        </vs-col>
                      </vs-row>

                      <vs-row class="ml-0 mb-2" v-if="showRecipientId">
                        <vs-col
                          vs-justify="left"
                          vs-align="center"
                          vs-w="10.8"
                          vs-sm="12"
                          vs-xs="12"
                          class="p-0">
                          <label for="customer-email">
                            Recipient's ID Number / Business Registration Number
                          </label>
                          <vs-input
                            class="inputx mb-3 w-full"
                            v-model.trim="recipientID"
                            id="recipient-id-number"
                            :disabled="inputDisabled" />
                        </vs-col>
                      </vs-row>

                      <vs-row class="ml-0 mb-2">
                        <vs-col
                          vs-justify="left"
                          vs-align="center"
                          vs-w="10.8"
                          vs-sm="12"
                          vs-xs="12"
                          class="p-0">
                          <label for="customer-email"> Recipient's Country </label>
                          <!--                <vs-input-->
                          <!--                  class="inputx mb-3 w-full"-->
                          <!--                  v-model="recipientCountry"-->
                          <!--                  id="recipient-country"-->
                          <!--                  :disabled="inputDisabled"-->
                          <!--                />-->
                          <select
                            id="recipient-country"
                            class="account-selection w-full style-select"
                            v-model="recipientCountry"
                            :disabled="inputDisabled">
                            <option
                              v-for="item in countries"
                              :value="item.code"
                              :key="item.code">
                              {{ item.name }} ({{ item.code }})
                            </option>
                          </select>
                        </vs-col>
                      </vs-row>

                      <br />

                      <vs-row class="ml-0 mb-2">
                        <vs-col
                          vs-justify="left"
                          vs-align="center"
                          vs-w="10.8"
                          vs-sm="12"
                          vs-xs="12"
                          class="p-0">
                          <VueFileAgent
                            class="w-100"
                            ref="vueFileAgent"
                            :theme="'list'"
                            :accept="'image/png,image/jpg,image/jpeg,.pdf'"
                            :deletable="true"
                            :multiple="false"
                            :maxFiles="1"
                            :maxSize="'20MB'"
                            :helpText="'Upload recipient proof of identity'"
                            v-model="fileRecords"
                            @beforedelete="onBeforeDelete($event)" />
                          <p>.png, .jpg, .jpeg, .pdf format</p>
                        </vs-col>
                      </vs-row>

                      <br />

                      <div class="mb-2">
                        <h6>
                          Secure payout using OTP (One-Time Password) (optional)
                        </h6>
                        <p class="sm:text-sm">
                          * Triggers an OTP to recipient phone when claiming funds
                        </p>
                      </div>

                      <vs-row class="ml-0 mb-4">
                        <vs-col
                          vs-justify="left"
                          vs-align="center"
                          vs-w="10.8"
                          vs-sm="12"
                          vs-xs="12"
                          class="p-0">
                          <label for="customer-email">
                            Recipient's Mobile Number
                          </label>
                          <vue-tel-input
                            v-model="recipientMobileNumber"
                            class="w-full mt-0 no-icon-border mb-0 tel-selection"
                            v-bind="phoneValidation"
                            @validate="phoneValidationMethod"
                            data-class="{'input-error-style': validateMerchantContactPhoneError}"
                            defaultCountry="SG"></vue-tel-input>
                        </vs-col>
                      </vs-row>

                      <vs-row class="mt-2 mb-2">
                        <span style="color: #ff0000; font-size: 10px; float: left">* Required</span>
                      </vs-row>

                      <vs-row
                        class="mt-2 mb-2"
                        v-if="validateWithdrawalAmountErrorTooSmall">
                        <p style="color: #ff0000">
                          Payout amount too small (less than USD 1 or equivalent).
                          Please try again.
                        </p>
                      </vs-row>

                      <vs-row
                        class="mt-2 mb-2"
                        v-if="validateWithdrawalErrorDueToExchangeRate">
                        <p style="color: #ff0000">
                          Unable to do payout, please try again in a few minutes.
                        </p>
                      </vs-row>

                      <vs-row vs-justify="flex-end" vs-align="center">
                        <vs-button
                          class="mt-3 mr-20"
                          @click="enabled2FA ? (show2faPrompt = true) : preview()">Preview</vs-button>
                      </vs-row>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <br />
                  <p>
                    You do not have permission to create a payout for this merchant.
                  </p>
                </div>
              </vs-col>
            </vs-row>
          </template>

          <!--Summary Container-->
          <template v-else>
            <vs-row class="mt-8">
              <vs-col
                type="flex"
                vs-justify="left"
                vs-align="center"
                vs-w="5.5"
                vs-xs="11"
                vs-sm="9">
                <h3 class="mb-2">Crypto Payout Summary</h3>
                <br />
                <div class="summary-container">
                  <vs-row>
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="10">
                      <span id="merchant-account-header" class="fw-500">
                        Sent From
                      </span>
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="1" vs-xs="1">
                      :
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="12">
                      <span id="merchant-account-value" class="fw-500">{{
                        selectedBalance.name.split('-')[0]
                        }}</span>
                    </vs-col>
                  </vs-row>

                  <vs-row class="mt-3 mb-3">
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="10">
                      <span id="balance-available-header" class="fw-500">Balance Available</span>
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="1" vs-xs="1">
                      :
                    </vs-col>
                    <vs-col
                      vs-justify="left"
                      vs-align="center"
                      vs-w="5"
                      vs-xs="12"
                      v-if="selectedBalance.available_currency === 'BTC' ||
    selectedBalance.available_currency === 'ETH' ||
    selectedBalance.available_currency === 'testBTC'
    ">
                      <span class="balance-available-value fw-500">{{ selectedBalance.available_currency }}{{ ' '
                        }}{{ formatCryptoPrice(selectedBalance.balance) }}</span>
                    </vs-col>
                    <vs-col
                      vs-justify="left"
                      vs-align="center"
                      vs-w="5"
                      vs-xs="12"
                      v-else>
                      <span class="balance-available-value fw-500">{{ selectedBalance.available_currency }}{{ ' '
                        }}{{ formatFiatPrice(selectedBalance.balance) }}</span>
                    </vs-col>
                  </vs-row>

                  <vs-row class="mt-3 mb-3">
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="10">
                      <span id="withdrawal-amount-header" class="fw-500">Payout Amount</span>
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="1" vs-xs="1">
                      :
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="12">
                      <span id="withdrawal-amount-value" class="fw-500">{{ withdrawalCurrency }}{{ ' '
                        }}{{ withdrawalAmount }}</span>
                    </vs-col>
                  </vs-row>

                  <vs-row
                    class="mt-3 mb-3"
                    v-if="selectedBalance &&
    selectedBalance.account_type === 'localcurrencyaccount'
    ">
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="10">
                      <span id="crypto-to-receive-in-header" class="fw-500">Cryptocurrency to receive in</span>
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="1" vs-xs="1">
                      :
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="12">
                      <span
                        class="crypto-to-receive-in-value fw-500"
                        v-if="cryptoCurrency === 'None'">{{ 'Recipient To Choose When Claiming Funds' }}</span>
                      <span class="crypto-to-receive-in-value fw-500" v-else>{{
                        cryptoCurrency
                        }}</span>
                    </vs-col>
                  </vs-row>

                  <vs-row class="mt-3 mb-3">
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="10">
                      <span id="customer-email-address-header" class="fw-500">Recipient's Email</span>
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="1" vs-xs="1">
                      :
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="12">
                      <span id="customer-email-address-value" class="fw-500">{{
                        customerEmailAddress
                        }}</span>
                    </vs-col>
                  </vs-row>

                  <vs-row class="mt-3 mb-3" v-if="recipientMobileNumber">
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="10">
                      <span id="recipient-mobile-number-header" class="fw-500">Recipient's Mobile Number</span>
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="1" vs-xs="1">
                      :
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="12">
                      <span id="recipient-mobile-number-value" class="fw-500">{{
                        recipientMobileNumber
                        }}</span>
                    </vs-col>
                  </vs-row>

                  <vs-row class="mt-3 mb-3" v-if="recipientName">
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="10">
                      <span id="recipient-name-header" class="fw-500">Recipient's Name</span>
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="1" vs-xs="1">
                      :
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="12">
                      <span id="recipient-name-value" class="fw-500">{{
                        recipientName
                        }}</span>
                    </vs-col>
                  </vs-row>
                  <!--Only show recipient ID field if the value is true (meaning id_number doesn't exist & need to collect)-->
                  <vs-row class="mt-3 mb-3" v-if="showRecipientId">
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="10">
                      <span id="recipient-id-number-header" class="fw-500">Recipient's ID Number / Business Registration Number</span>
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="1" vs-xs="1">
                      :
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="12">
                      <span id="recipient-id-number-value" class="fw-500">{{
                        recipientID
                        }}</span>
                    </vs-col>
                  </vs-row>

                  <vs-row class="mt-3 mb-3" v-if="recipientCountry">
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="10">
                      <span id="recipient-country-header" class="fw-500">Recipient's Country</span>
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="1" vs-xs="1">
                      :
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="12">
                      <span id="recipient-country-value" class="fw-500">{{
                        countries.find((item) => item.code === recipientCountry)
                        .name
                        }}</span>
                    </vs-col>
                  </vs-row>

                  <vs-row class="mt-3 mb-3" v-if="fileRecords.length > 0">
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="10">
                      <span id="recipient-POI-header" class="fw-500">Recipient's POI uploaded ?
                      </span>
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="1" vs-xs="1">
                      :
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="12">
                      <span id="recipient-POI-value" class="fw-500">Yes</span>
                    </vs-col>
                  </vs-row>

                  <vs-row>
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="10">
                      <span id="remarks-header" class="fw-500">Reference</span>
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="1" vs-xs="1">
                      :
                    </vs-col>
                    <vs-col vs-justify="left" vs-align="center" vs-w="5" vs-xs="12">
                      <span id="remarks-value" class="fw-500">{{
                        withdrawalRemarks
                        }}</span>
                    </vs-col>
                  </vs-row>
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="mt-4 mb-3">
              <vs-col
                type="flex"
                vs-justify="left"
                vs-align="center"
                vs-w="5.5"
                vs-xs="11"
                vs-sm="9">
                <div style="font-weight: 500; font-size: 15px" class="mt-2 mb-3">
                  Are you sure you want to approve the payout ?
                </div>
                <div style="display: flex; justify-content: flex-end">
                  <vs-button color="danger" @click="cancelWithdrawal()">Cancel</vs-button>
                  <vs-button
                    class="vs-con-loading__container"
                    @click="proceedWithdrawal()"
                    id="create-payout-btn"
                    ref="loadableButton"
                    color="primary"
                    :disabled="disableProceedButton">Proceed</vs-button>
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="mt-5 mb-3" v-if="withdrawalError">
              <vs-col
                type="flex"
                vs-justify="left"
                vs-align="center"
                vs-w="5.5"
                vs-xs="11"
                vs-sm="9">
                <ul>
                  <li
                    v-for="(reason, index) in withdrawalErrorReason"
                    style="font-weight: 500; color: red"
                    :key="index">
                    {{ reason }}
                  </li>
                </ul>
              </vs-col>
            </vs-row>

            <vs-row class="mt-5 mb-3" v-if="validatePhoneNumberError">
              <vs-col
                type="flex"
                vs-justify="left"
                vs-align="center"
                vs-w="5.5"
                vs-xs="11"
                vs-sm="9">
                <span style="font-weight: 500; color: red">
                  Mobile number is invalid. Please insert a valid format of mobile
                  number. (eg. +countrycode mobilenumber)</span>
              </vs-col>
            </vs-row>
          </template>
        </div>

        <div id="withdrawal-approved" class="withdrawal-approved"  v-else>
          <div style="display: flex; align-items: center">
            <info-icon size="1.5x" class="custom-class"></info-icon>
            <span style="margin: 0px 5px"><strong>The payout process is underway. You will receive an email
                notification once it is completed.</strong></span>
          </div>
          <div style="margin-top: 15px">
            <vs-button type="border" @click="goToDashboard()">
              Go to Homepage
            </vs-button>
            <vs-button @click="goToStartOfCreation()">
              Create Another Payout
            </vs-button>

          </div>
        </div>
      </section>
      <!-- Payout Direct -->
      <Crypto-payout-direct v-else-if="selectedPayoutType === PAYOUT_TYPES.DIRECT" />
      <!-- Batch payouts -->
      <Crypto-payout-batch v-else-if="selectedPayoutType === PAYOUT_TYPES.BATCH" />
    </Transition>

    <otp-prompt
      :login="$store.state.activeUser.email"
      :active.sync="show2faPrompt"
      otpRequired
      @verify="
      verified2FA = true;
      preview($event);
    " />
  </main>
</template>

<script>
import Vue from 'vue';
import { InfoIcon } from 'vue-feather-icons';
import { mapGetters } from 'vuex';
import { VueTelInput } from 'vue-tel-input';

import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';

import OtpPrompt from '@/components/OtpPrompt';
import { COUNTRIES } from '../../constants';
import CryptoPayoutDirect from '../../organisms/CryptoPayoutDirect.vue';
import CryptoPayoutBatch from '../../organisms/CryptoPayoutBatch.vue';

Vue.use(VueTelInput);
Vue.use(VueFileAgent);
Vue.use(VueFileAgentStyles);

export default {
  components: {
    InfoIcon,
    VueTelInput,
    // VueFileAgent
    OtpPrompt,
    CryptoPayoutDirect,
    CryptoPayoutBatch,
  },
  props: {
    type : {
      type: String,
      default: 'email'
    }
  },

  data() {
    return {
      show2faPrompt: false,
      verified2FA: false,
      customerEmailAddress: '',
      withdrawalCurrency:
        this.$store.getters.activeMerchantGetter.local_currency || 'USD',
      withdrawalAmount: null,
      withdrawalRemarks: '',
      selectedBalance: null,

      validateEmailError: false,
      validateWithdrawalAmountError: false,
      validateCurrencyError: false,
      validateWithdrawalAccountError: false,
      validateWithdrawalRemarksError: false,
      validateWithdrawalAmountErrorTooSmall: false,
      validateWithdrawalErrorDueToExchangeRate: false,

      isProceed: false,
      formSubmitted: false,

      withdrawalApproved: false,
      withdrawalError: false,
      withdrawalErrorReason: [],

      inputDisabled: false,

      debugConsole: false,

      cryptoCurrency: 'None',
      validateWithdrawalCryptoError: false,
      showCryptoField: false,

      debugConsoleForSmallWithdrawalAmount: false,

      //kycc needed, but optional
      recipientMobileNumber: '',
      phoneValidation: {
        inputOptions: {
          showDialCode: true,
        },
        placeholder: 'Enter a phone number',
        disabledFetchingCountry: true,
        enabledCountryCode: false,
        validCharactersOnly: true,
      },
      phoneValidationError: false,
      validatePhoneNumberError: false,

      recipientName: '',
      recipientID: '',
      recipientCountry: '',

      countries: COUNTRIES,

      fileRecords: [],
      s3Data: null,

      showRecipientId: false,

      //displays content depends on the user's permission
      displayPayoutLinkCreation: false,

      //check if 2fa is enabled
      enabled2FA: false,

      // list of cryptos
      cryptoList: ['BTC', 'ETH', 'USDT', 'USDC', 'USDT_TRC20'],

      eventPayload: null,
      disableProceedButton: false,

      PAYOUT_TYPES: {
        EMAIL: 'email',
        DIRECT: 'direct',
        BATCH: 'batch',
      },
      selectedPayoutType: 'email', // email || direct || batch
    };
  },
  computed: {
    ...mapGetters([
      'activeAccountGetter',
      'localCurrencyGetter',
      'merchantsGetter',
      'activeMerchantGetter',
      'merchantBankAccountGetter',
      'merchantProfileDetailsGetter',
      'currentActiveEntityAdminGetter',
    ]),
    activeAccountName() {
      return this.$store.getters.activeAccountGetter.name;
    },
    withdrawalAccountList() {
      // list the account balances from the merchants
      // let merchants = this.$store.getters.merchantsGetter;

      let activeMerchant = this.activeMerchantGetter;
      if (this.debugConsole) {
        console.log('Active Merchant in withdrawal page', activeMerchant);
      }


      let withdrawalArr = [];
      for (let k = 0; k < activeMerchant.balances.length; k++) {
        if (
          activeMerchant.can_withdraw &&
          activeMerchant.balances[k].type === 'test'
        ) {
          //for testBTC custody account
          if (activeMerchant.balances[k].available_currency === 'testBTC') {
            let obj = {};
            obj.name =
              activeMerchant.merchant_name +
              ' (Custody Account) ' +
              ' - ' +
              activeMerchant.balances[k].available_currency +
              ' ' +
              activeMerchant.balances[k].available_amount;
            obj.balance = activeMerchant.balances[k].available_amount;
            obj.type = activeMerchant.balances[k].type;
            obj.merchant_key = activeMerchant.merchant_key;
            obj.available_currency =
              activeMerchant.balances[k].available_currency;
            obj.account_type = 'custodyaccount';
            withdrawalArr.push(obj);
          } else {
            let obj = {};
            obj.name =
              activeMerchant.merchant_name +
              ' (Local Currency Account) ' +
              ' - ' +
              activeMerchant.balances[k].available_currency +
              ' ' +
              activeMerchant.balances[k].available_amount;
            obj.balance = activeMerchant.balances[k].available_amount;
            obj.type = activeMerchant.balances[k].type;
            obj.merchant_key = activeMerchant.merchant_key;
            obj.available_currency =
              activeMerchant.balances[k].available_currency;
            obj.account_type = 'testaccount';
            withdrawalArr.push(obj);
          }
        } else if (
          activeMerchant.can_withdraw &&
          activeMerchant.balances[k].type === 'real'
        ) {
          if (
            this.cryptoList.includes(
              activeMerchant.balances[k].available_currency
            )
          ) {
            let obj = {};
            obj.name =
              activeMerchant.merchant_name +
              ' (Custody Account) ' +
              ' - ' +
              activeMerchant.balances[k].available_currency +
              ' ' +
              activeMerchant.balances[k].available_amount;
            obj.balance = activeMerchant.balances[k].available_amount;
            obj.type = activeMerchant.balances[k].type;
            obj.merchant_key = activeMerchant.merchant_key;
            obj.available_currency =
              activeMerchant.balances[k].available_currency;
            obj.account_type = 'custodyaccount';
            withdrawalArr.push(obj);
          } else {
            let obj = {};
            obj.name =
              activeMerchant.merchant_name +
              ' (Local Currency Account) ' +
              ' - ' +
              activeMerchant.balances[k].available_currency +
              ' ' +
              this.formatFiatPrice(activeMerchant.balances[k].available_amount);
            obj.balance = activeMerchant.balances[k].available_amount;
            obj.type = activeMerchant.balances[k].type;
            obj.merchant_key = activeMerchant.merchant_key;
            obj.available_currency =
              activeMerchant.balances[k].available_currency;
            obj.account_type = 'localcurrencyaccount';
            withdrawalArr.push(obj);
          }
        }
      }

      if (this.debugConsole) {
        console.log('Withdrawal Arr', withdrawalArr);
      }
      return withdrawalArr;

      // let arr = [];
      // for (let i = 0 ; i < merchants.length; i++)
      // {
      //   for(let j = 0; j < merchants[i].balances.length; j++){
      //       // let obj = {};
      //       if(merchants[i].can_withdraw && merchants[i].balances[j].type === 'test' && merchants[i].balances[j].available_currency === "USD" ){
      //         let obj = {};
      //         obj.name = merchants[i].merchant_name + ' (testBTC) ' +  ' - ' + merchants[i].balances[j].available_currency + ' ' + this.formatFiatPrice(merchants[i].balances[j].available_amount);
      //         obj.balance = merchants[i].balances[j].available_amount;
      //         obj.type = merchants[i].balances[j].type;
      //         obj.merchant_key = merchants[i].merchant_key;
      //         obj.available_currency = merchants[i].balances[j].available_currency;
      //         arr.push(obj);
      //       }
      //       else if(merchants[i].can_withdraw && merchants[i].balances[j].type === 'real' && merchants[i].balances[j].available_currency === "USD"){
      //         let obj = {};
      //         obj.name = merchants[i].merchant_name + ' (BTC) ' + ' - ' + merchants[i].balances[j].available_currency + ' ' + this.formatFiatPrice(merchants[i].balances[j].available_amount);
      //         obj.balance = merchants[i].balances[j].available_amount;
      //         obj.type = merchants[i].balances[j].type;
      //         obj.merchant_key = merchants[i].merchant_key;
      //         obj.available_currency = merchants[i].balances[j].available_currency;
      //         arr.push(obj);
      //       }

      // obj.balance = merchants[i].balances[j].available_amount;
      // obj.type = merchants[i].balances[j].type;
      // obj.merchant_key = merchants[i].merchant_key;
      // obj.available_currency = merchants[i].balances[j].available_currency;
      // arr.push(obj);
      //   }
      // }
      // if(this.debugConsole)
      //   console.log('arr', arr);

      // return arr;
    },
    realWithdrawalAccountsList() {
      //list the account for real balance
      let arr = [];
      (this.withdrawalAccountList || []).forEach((item) => {
        if (item.type === 'real' && !this.isCryptoCurrency(item.available_currency)) {
          arr.push(item);
        }
      });
      return arr;
    },
    testWithdrawalAccountList() {
      //list the account for test balance
      let arr = [];
      (this.withdrawalAccountList || []).forEach((item) => {
        if (item.type === 'test') {
          arr.push(item);
        }
      });
      if (this.debugConsole) {
        console.log('Test arr', arr);
      }

      // console.log('Test arr', arr);
      return arr;
    },

    cryptoOptionsToWithdrawForLocal() {
      let selectedMerchantForWithdrawal =
        this.selectedBalance &&
        this.merchantsGetter.find(
          (el) => el.merchant_key === this.selectedBalance.merchant_key
        );

      //search for the real localcurrency account and return the one without test. Also to check if it is a wallet provider (BINANCE, CRYPTO.COM, etc) by calculating the length
      let localCurrencyCryptoOptions =
        selectedMerchantForWithdrawal &&
        selectedMerchantForWithdrawal.accounts
          .filter(
            (el) =>
              el.settlement_type === 'localcurrency' &&
              (el.crypto_currency.indexOf('test') < 0 ||
                el.api_id.indexOf('_t') < 0) &&
              !el.crypto_currency.includes('BINANCE') &&
              !el.crypto_currency.includes('LNBC')
          )
          .map((el) => el.crypto_currency);

      let uniqueListOfCryptos = Array.from(
        new Set(localCurrencyCryptoOptions)
      ).sort();
      uniqueListOfCryptos.push('None'); // to keep the none option at the end

      return uniqueListOfCryptos;
    },

    isWhiteListedForBatch() {
      return this.isWhitelistedForCryptoBatch();
    }
  },
  mounted() {
    this.apiGetMerchants();
    this.checkRights();
    //check if 2FA is enabled for selected Merchant
    this.enabled2FA = this.is2faEnabled(
      this.activeMerchantGetter,
      'manual_payout'
    );
    this.selectedPayoutType = this.type;
  },
  methods: {
    checkRights() {
      //check the permission of the user in the default selected merchant
      const currentActiveMerchantId = this.activeMerchantGetter && this.activeMerchantGetter.id;
      //determine to show if the user has permission to create a payout or not
      this.displayPayoutLinkCreation = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        currentActiveMerchantId,
        'payout_links',
        'W'
      );
    },
    disableButtonLoader() {
      this.$vs.loading.close(this.$refs.loadableButton.$el);
    },
    onChangeEmailAddress() {
      if (this.debugConsole) {
        console.log('Email Address inserted', this.customerEmailAddress);
      }

      // call the get recipient/payee data once email is inserted

      if (this.debugConsole) {
        console.log('Selected Balance', this.selectedBalance);
      }

      let merchantKey = this.selectedBalance.merchant_key;

      let data = {};
      data.email = this.customerEmailAddress.trim();
      data.merchant_key = merchantKey;

      if (this.debugConsole) {
        console.log('Payload to get recipient', data);
      }

      this.getMerchantToken(merchantKey)
        .then((res) => {
          if (this.debugConsole) {
            console.log('Special Access Token', res);
          }

          let token = res.data && res.data.access_token;

          this.getRecipientDetails(token, data)
            .then((res) => {
              if (this.debugConsole) {
                console.log('Result in getting recipient KYC', res);
              }

              //for recipient id , we don't show the field if there is data (value is true), we show the field if there is no data
              if (res.data.id_num) {
                //don't show the field
                this.showRecipientId = false;
              } else {
                //show the field
                this.showRecipientId = true;
                this.recipientID = '';
              }
              // this.recipientID = res.data.id_num ? res.data.id_num : "";
              this.recipientName = res.data.name ? res.data.name : '';
              this.recipientCountry = res.data.country ? res.data.country : '';
            })
            .catch((err) => {
              console.log('Error in getting recipient KYC', err);
            });
        })
        .catch((err) => {
          console.log('Failed to get withdrawal Token', err);
        });
    },
    async preview(eventPayload) {
      this.eventPayload = eventPayload;
      this.formSubmitted = true;

      this.resetEmailPayoutErrors();
      if (!this.selectedBalance) {
        this.validateWithdrawalAccountError = true;
      }

      if (
        !this.customerEmailAddress ||
        (this.customerEmailAddress &&
          this.customerEmailAddress.indexOf('@') < 2)
      ) {
        this.validateEmailError = true;
      }

      if (!this.withdrawalCurrency) {
        this.validateCurrencyError = true;
      }

      if (
        !this.withdrawalAmount ||
        (this.withdrawalAmount && this.withdrawalAmount <= 0.0) ||
        this.withdrawalAmount > this.selectedBalance.balance
      ) {
        this.validateWithdrawalAmountError = true;
      }

      if (this.withdrawalRemarks && this.withdrawalRemarks.length > 40) {
        this.validateWithdrawalRemarksError = true;
      }

      if (
        this.selectedBalance &&
        this.selectedBalance.account_type === 'localcurrencyaccount'
      ) {
        // UPDATE : OPTIONAL FOR PAYOUT INITIATOR TO CHOOSE WHICH CRYPTO OR NONE (NONE MEANS RECIPIENT TO CHOOSE THE CRYPTO)
        if (!this.cryptoCurrency) {
          this.validateWithdrawalCryptoError = true;
        }
        //ONLY FOR BTC

        //Check if the crypto currency is in BTC.
        if (this.cryptoCurrency === 'BTC') {
          //if BTC, check the withdrawal currency is it in USD.
          if (this.withdrawalCurrency !== 'USD') {
            // if not in USD, calculate the USD equivalent using exchange rate.
            //get the BTC API ID, from mkey of selected balance and then from mkey, search the BTC API ID
            let merchantKey =
              this.selectedBalance && this.selectedBalance.merchant_key;

            let findMerchant =
              this.merchantsGetter &&
              this.merchantsGetter.find(
                (item) => item.merchant_key === merchantKey
              );

            let apiId = findMerchant.accounts.find(
              (item) => item.crypto_currency === 'BTC'
            ).api_id;

            let data = {};
            data.apiId = apiId;
            data.fiatCurrency = this.withdrawalCurrency;
            // data.amount = this.withdrawalAmount;

            try {
              let result = await this.getExchangeRateToUSD(data);
              if (result.status === 200) {
                this.validateWithdrawalErrorDueToExchangeRate = false;

                let excRate = result.data.exchange_rate;
                // USD equivalent amount of the refund amount
                let usdAmountEquivalent = this.withdrawalAmount / excRate;

                if (usdAmountEquivalent < 1) {
                  this.validateWithdrawalAmountErrorTooSmall = true;
                }
                //some exchange rate convert to USD might return 0, need to know which exc rate does this
                else if (!isFinite(usdAmountEquivalent)) {
                  this.validateWithdrawalErrorDueToExchangeRate = true;
                } else {
                  this.validateWithdrawalAmountErrorTooSmall = false;
                }
              } else {
                console.error('Unsuccessful in getting the exchange rate');
                this.validateWithdrawalErrorDueToExchangeRate = true;
              }
            } catch (err) {
              console.log('Error in getting exchange rate', err);
              this.validateWithdrawalErrorDueToExchangeRate = true;
            }
          } else {
            if (this.withdrawalAmount < 1) {
              this.validateWithdrawalAmountErrorTooSmall = true;
            }
          }
        } else {
          this.validateWithdrawalAmountErrorTooSmall = false;
        }

        if (
          this.validateEmailError ||
          this.validateCurrencyError ||
          this.validateWithdrawalAmountError ||
          this.validateWithdrawalRemarksError ||
          this.validateWithdrawalCryptoError ||
          this.validateWithdrawalAmountErrorTooSmall ||
          this.validateWithdrawalErrorDueToExchangeRate
        ) {
          return;
        }
      } else {
        if (
          this.validateEmailError ||
          this.validateCurrencyError ||
          this.validateWithdrawalAmountError ||
          this.validateWithdrawalRemarksError
        ) {
          console.log('ValidateEmailError', this.validateEmailError);
          console.log('validateCurrencyError', this.validateCurrencyError);
          console.log(
            'validateWithdrawalAmountError',
            this.validateWithdrawalAmountError
          );
          console.log(
            'validateWithdrawalRemarksError',
            this.validateWithdrawalRemarksError
          );
          return;
        }
      }

      this.isProceed = true;
      this.inputDisabled = true;
    },

    phoneValidationMethod({ isValid }) {
      if (isValid) {
        this.phoneValidationError = false;
      } else {
        this.phoneValidationError = true;
      }
    },

    cancelWithdrawal() {
      this.isProceed = false;
      this.inputDisabled = false;
      this.withdrawalError = false;
      this.withdrawalErrorReason = [];
      this.validatePhoneNumberError = false;
    },
    proceedWithdrawal() {
      //check if it is custody or local currency
      if (this.debugConsole) {
        console.log('This selectedBalance', this.selectedBalance);
      }

      //loader for the confirm refund button and disable the button
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: this.$refs.loadableButton.$el,
        scale: 0.45,
      });
      this.disableProceedButton = true;

      this.$recaptchaLoaded().then(() => {
        this.$recaptcha('browser_access').then((token) => {
          this.disableButtonLoader();
          //if it is custody acc (both for real or test)
          if (this.selectedBalance.account_type === 'custodyaccount') {
            if (this.debugConsole) {
              console.log('Withdrawal for custody account');
            }
            let merchantKey = this.selectedBalance.merchant_key;

            let withdrawalData = {};
            withdrawalData.merchant_key = merchantKey;
            withdrawalData.email = this.customerEmailAddress.trim();
            withdrawalData.crypto_currency = this.withdrawalCurrency;
            withdrawalData.crypto_amount = parseFloat(this.withdrawalAmount);
            withdrawalData.remarks = this.withdrawalRemarks;
            if (this.recipientMobileNumber) {
              withdrawalData.mobile_phone = this.recipientMobileNumber;
            }
            if (this.recipientName) {
              withdrawalData.name = this.recipientName;
            }

            if (this.showRecipientId) {
              if (this.recipientID) {
                withdrawalData.id_number = this.recipientID;
              }
            }

            if (this.recipientCountry) {
              withdrawalData.country = this.recipientCountry;
            }

            // add recaptcha
            withdrawalData.recaptchaToken = token;

            if (this.eventPayload) {
              withdrawalData[`${Object.keys(this.eventPayload)[0]}`] = Object.values(this.eventPayload)[0];
            }

            if (this.debugConsole) {
              console.log('Withdrawal Data Custody to Crypto', withdrawalData);
            }


            this.createWithdrawalCustody(withdrawalData)
              .then((res) => {
                if (this.debugConsole) {
                  console.log('Create Withdrawal result custody to crypto', res);
                }

                if (res.status === 200) {
                  this.withdrawalApproved = true;
                  //call the get merchant api to update
                  this.apiGetMerchants();
                } else {
                  this.withdrawalError = true;
                }
                this.disableProceedButton = false;
              })
              .catch((err) => {
                this.disableProceedButton = false;
                this.withdrawalCreationError(err);
              });
          }
          //other than custody acc
          else {
            if (this.debugConsole) {
              console.log('Withdrawal for local currency account');
            }

            let merchantKey = this.selectedBalance.merchant_key;

            let withdrawalData = {};
            withdrawalData.merchant_key = merchantKey;
            withdrawalData.email = this.customerEmailAddress.trim();
            withdrawalData.withdraw_currency = this.withdrawalCurrency;
            withdrawalData.withdraw_amount = parseFloat(this.withdrawalAmount);
            withdrawalData.created_by = this.currentActiveEntityAdminGetter.id;

            if (this.recipientMobileNumber) {
              withdrawalData.mobile_phone = this.recipientMobileNumber;
            }

            if (this.recipientName) {
              withdrawalData.name = this.recipientName;
            }

            if (this.showRecipientId) {
              if (this.recipientID) {
                withdrawalData.id_number = this.recipientID;
              }
            }

            if (this.recipientCountry) {
              withdrawalData.country = this.recipientCountry;
            }

            if (this.selectedBalance.type !== 'test') {
              withdrawalData.crypto_currency =
                this.cryptoCurrency === 'None' ? null : this.cryptoCurrency;
            } else {
              withdrawalData.crypto_currency = 'testBTC';
            }
            withdrawalData.remarks = this.withdrawalRemarks;

            if (this.debugConsole) {
              console.log('Withdrawal Data Local to crypto', withdrawalData);
            }

            // add recaptcha
            withdrawalData.recaptchaToken = token;

            if (this.eventPayload) {
              withdrawalData[`${Object.keys(this.eventPayload)[0]}`] = Object.values(this.eventPayload)[0];
            }

            //check if there is a file uploaded for Payee POI
            if (this.fileRecords.length > 0) {
              if (this.debugConsole) {
                console.log('POI File', this.fileRecords[0]);
              }

              let data = {};
              data.mimeType = this.fileRecords[0].type;
              data.merchantKey = this.selectedBalance.merchant_key;

              if (this.debugConsole) {
                console.log('Data for getting S3 upload', data);
              }


              this.getS3DataForPayeePOIUpload(data)
                .then((res) => {
                  if (this.debugConsole) {
                    console.log('Result from getting S3 data for payee POI', res);
                  }

                  let s3Data = res.data;

                  let payload = {};
                  payload.contentType = this.fileRecords[0].type;
                  payload.file = this.fileRecords[0].file;
                  payload.s3Data = s3Data;

                  this.uploadPayeePOI(payload)
                    .then((res) => {
                      if (this.debugConsole) {
                        console.log('Upload Payee POI response', res);
                      }

                      this.$vs.loading({
                        container: '#create-payout-btn',
                        scale: 0.45,
                        color: 'primary',
                      });

                      //pass the payee_poi if file is uploaded
                      withdrawalData.payee_poi = s3Data.fields.key;
                      this.createWithdrawalLocalToCrypto(withdrawalData)
                        .then((res) => {
                          if (this.debugConsole) {
                            console.log(
                              'Create Withdrawal result local to crypto',
                              res
                            );
                          }

                          if (res.status === 200) {
                            this.withdrawalApproved = true;
                            this.$vs.loading.close(
                              '#create-payout-btn > .con-vs-loading'
                            );
                            //call the get merchant api to update
                            this.apiGetMerchants();
                          }
                          this.disableProceedButton = false;
                        })
                        .catch((err) => {
                          this.disableProceedButton = false;
                          this.$vs.loading.close(
                            '#create-payout-btn > .con-vs-loading'
                          );
                          this.withdrawalCreationError(err);
                        });
                    })
                    .catch((err) => {
                      console.log('Error in uploading payee poi', err);
                    });
                })
                .catch((err) => {
                  console.log('Error in getting s3 data for payee POI', err);
                });
            }
            // if no file is provided for payer POI, call the create payout API immediately
            else {
              this.createWithdrawalLocalToCrypto(withdrawalData)
                .then((res) => {
                  if (this.debugConsole) {
                    console.log('Create Withdrawal result local to crypto', res);
                  }

                  if (res.status === 200) {
                    this.withdrawalApproved = true;
                    //call the get merchant api to update balance
                    this.apiGetMerchants().then(res => {
                      this.$store.commit('UPDATE_ACTIVE_MERCHANT', res.data.find(merchant => merchant.merchant_key === merchantKey));
                    });
                    this.disableProceedButton = false;
                  }
                })
                .catch((err) => {
                  this.disableProceedButton = false;
                  this.withdrawalCreationError(err);
                });
            }
          }
        }).catch(() => {
          this.$vs.notify({
            title: 'Recaptcha Error',
            text: 'Error in creating payout. Please refresh or try re-login again.',
            color: 'danger',
          });

        });
      });


    },
    goToDashboard() {
      this.$router.push('/home');
    },

    showTooltip(target) {
      let tooltip = document.getElementById(target);

      if (tooltip) {
        tooltip.style.visibility = 'visible';
        setTimeout(function () {
          tooltip.style.visibility = 'hidden';
        }, 3000);
      }
    },
    onBeforeDelete: function (fileRecord) {
      if (this.debugConsoleLog) {
        window.console.log('File Record before delete', fileRecord);
      }

      this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
    },
    withdrawalCreationError(err) {
      // reset errors
      this.withdrawalError = false;
      this.withdrawalErrorReason = [];
      // Add new errors
      if (
        err.response.data &&
        err.response.data.errors &&
        err.response.data.errors[0].message === 'invalid' &&
        err.response.data.errors[0].path === 'mobile_phone'
      ) {
        //if mobile phone format is invalid
        this.validatePhoneNumberError = true;
      } else {
        this.withdrawalError = true;
        if (err.response.status === 403) {
          this.withdrawalErrorReason.push(
            'Payee details are incorrect. Please check the details and try again.'
          );
        } else if (err.response.status === 409) {
          this.withdrawalErrorReason.push(
            'Sorry, we are unable to process this payout to this user / address. Please contact Support for assistance to investigate this case further.'
          );
        }
        else if (err.response.status === 401) {
          this.withdrawalErrorReason.push(
            'Invalid authorisation for creating payout. Please try again.'
          );
        } else if (err.response.status === 404) {
          this.withdrawalErrorReason.push('Merchant not found.');
        } else if (err.response.status === 422) {
          // error in form
          const formErrors = [];
          for (let e of err.response.data.errors) {
            formErrors.push(this.formatErrMessage(e));
          }
          this.withdrawalErrorReason.push(
            'The payout details are incorrect, your request has been rejected. Please check again : '.concat(
              formErrors.join(', ')
            )
          );
        } else {
          this.withdrawalErrorReason.push(
            'Something went wrong, no payout has been created. Please check your request details and try again.'
          );
        }
      }
    },
    formatErrMessage(error) {
      if (error.message === 'balance_short') {
        return 'Sorry you may have exceeded the amount available for payout. Please check your available balance and enter a smaller amount to payout.';
      } else {
        if (error.path) {
          return error.message + ' ' + error.path.replace(/_/g, ' ');
        } else {
          return error.message.replace(/_/g, ' ');
        }
      }
    },

    goToStartOfCreation() {
      this.resetEmailPayoutForm();
      this.resetEmailPayoutErrors();
      this.resetKYCFields();
      // go back to the start of the creation
      this.inputDisabled = false;
      this.showCryptoField = false;
      this.isProceed = false;
      this.withdrawalApproved = false;
      this.formSubmitted = false;
    },

    resetEmailPayoutErrors() {
      this.validateWithdrawalAccountError = false;
      this.validateEmailError = false;
      this.validateCurrencyError = false;
      this.validateWithdrawalAmountError = false;
      this.validateWithdrawalCryptoError = false;
      this.validateWithdrawalRemarksError = false;
      this.validateWithdrawalAmountErrorTooSmall = false;

      this.withdrawalError = false;
    },

    resetEmailPayoutForm() {
      this.selectedBalance = null; 
      this.customerEmailAddress = '';
      this.withdrawalCurrency = '';
      this.withdrawalAmount = '';
      this.cryptoCurrency = 'None';
      this.withdrawalRemarks = '';
    },

    resetKYCFields() {
      this.recipientMobileNumber = '';
      this.recipientName = '';
      this.recipientID = '';
      this.recipientCountry = '';
      this.fileRecords = [];
      this.validatePhoneNumberError = false;
    },
  },
  watch: {
    selectedBalance: function (newVal) {
      if (!newVal) {
        this.withdrawalCurrency = '';
        this.showCryptoField = false;
      } else {
        this.withdrawalCurrency = newVal.available_currency;
        //whether to show the crypto field or not (UPDATE : NO NEED TO DEFINE THE CRYPTO FOR DASHBOARD)
        this.showCryptoField = newVal.type === 'real' && newVal.account_type === 'localcurrencyaccount';
      }
    },
    activeMerchantGetter: function (newVal) {
      this.checkRights();
      //check if 2FA is enabled for selected Merchant
      this.enabled2FA = this.is2faEnabled(newVal, 'manual_payout');
    },
  },
};
</script>

<style lang="scss" scoped>
main {
  position: relative;
}

.email-payout-wrapper {
  .account-selection {
    height: 36px;
    border-radius: 5px;
    border: 1px solid #cdcdcd;
    padding: 3px;
    background-color: white !important;
    font-family: 'Montserrat', Helvetica, Arial, sans-serif;
    font-size: 14px;
  }

  .select-icon-validate-danger {
    border: 1px solid rgba(var(--vs-danger), 1) !important;
  }

  .withdrawal-container {
    display: flex;
    flex-direction: column;
  }

  .withdrawal-message {
    display: flex;
    flex-direction: column;
  }

  .summary-container {
    background-color: #ffffff;
    padding: 30px 0px;
    margin: 10px 0;
    border-radius: 10px;
  }

  .cancel-btn {
    display: inline-block;
    border: 2px solid #d9534f;
    text-align: center;
    cursor: pointer;
    padding: 10px;
    margin: 0 10px;
    background-color: #ffff;
    color: #d9534f;
    border-radius: 5px;
  }

  .confirm-btn {
    display: inline-block;
    border: 2px solid #075593;
    text-align: center;
    cursor: pointer;
    padding: 10px;
    margin: 0 10px;
    background-color: #ffffff;
    color: #075593;
    border-radius: 5px;
  }

  .cancel-btn:hover {
    display: inline-block;
    border: none;
    text-align: center;
    cursor: pointer;
    padding: 10px;
    margin: 0 10px;
    background-color: #d9534f;
    color: #ffffff;
    border-radius: 5px;
  }

  .confirm-btn:hover {
    display: inline-block;
    border: none;
    text-align: center;
    cursor: pointer;
    padding: 10px;
    margin: 0 10px;
    background-color: #075593;
    color: #ffffff;
    border-radius: 5px;
  }

  .withdrawal-approved {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-top: $margin-m;
    padding: $margin-m;
  }

  .tooltip-container {
    position: relative;
    display: inline-block;
  }

  #tooltip-msg {
    visibility: hidden;
    display: flex;
    flex-direction: column;
    background-color: lightslategray;
    width: 275px;
    padding: 10px;
    border-radius: 5px;
    color: #ffffff;
    font-size: 10px;
    text-align: center;
    position: absolute;
    z-index: 1;
    left: 105%;
    top: -20px;
  }

  .textarea-style {
    background-color: #ffffff !important;
  }

  .tooltip-container:hover #tooltip-msg {
    visibility: visible;
  }

  .fw-500 {
    font-weight: 500;
  }

  @media screen and (min-width: 901px) {
    #settlement-summary {
      height: 80px;
    }

    .space-between-content-items {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-content: space-between;
      padding-right: 1rem !important;
    }
  }

  @media screen and (max-width: 900px) {
    #settlement-summary {
      height: 140px;
    }

    .space-between-content-items {
      padding-right: 0 !important;
      padding-bottom: 0.8rem !important;

      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-content: space-between;

      .vs-col {
        padding-right: 0.6rem !important;
        padding-left: 0.6rem !important;
      }

      .vs-col:first-child {
        padding-left: 0 !important;
      }

      .vs-col:last-child {
        padding-right: 0 !important;
      }
    }
  }

  #withdrawal-currency {
    height: 36px;
    border-radius: 5px;
    border: 1px solid #cdcdcd;
    padding: 5px;
    font-family: 'Montserrat', Helvetica, Arial, sans-serif;
    font-size: 14px;
    position: relative;
  }

  #withdrawal-currency>span {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
}

.payout-type-selection-wrapper {
  margin-top: $margin-m;
  margin-bottom: $margin-m;

  input[type='radio'] {
    display: none;
  }

  label {
    position: relative;
    padding: 12px;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    cursor: pointer;
    background-color: $color-selectable;
    color: $color-text;
    border: none;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:not(:last-child) {
      margin-right: 6px;
    }

    svg {
      position: relative;
      top: 8px;
    }

    &:hover {
      color: $color-primary-light;

      svg {
        fill: $color-primary-light;
      }
    }
  }

  input[type="radio"]:checked+label {
    color: $color-primary-light;
    border-bottom: 4px solid $color-primary-light;

    svg {
      fill: $color-primary-light;
    }
  }
}
</style>
